import { Typography } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import { Container } from "@mui/material";
import "./Support.css";
import Stack from '@mui/material/Stack';
import { useLocation, useNavigate } from "react-router-dom";
import backarr from '../../Images/Layer2.svg'
import Grid from "@mui/material/Grid2";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import socket from "../../utils/Socket";
import { createChat, getChats } from "../../Services/support";
import { ToastError } from "../../CustomToaster/CustomToaster";
import noImage from "../../Images/nodata.webp";
import noProfile from "../../Images/prfImg.webp";
import ChatSkeletonLoader from "../Skeleton/ChatSkeleton";


const ImageChecker = ({ src, alt, style, className, fallback = null }) => {
    const [imageSrc, setImageSrc] = useState(src);

    useEffect(() => {
        setImageSrc(src);
    }, [src]);

    return (
        <img
            src={imageSrc}
            alt={alt}
            className={className ? className : ""}
            style={style}
            onError={() => setImageSrc(fallback || noProfile)} // Replace with fallback on error
        />
    );
};

const Support2 = () => {

    const navigate = useNavigate();
    const [message, setMessage] = useState([
        "Hello!",
        "How are you?",
        "I'm fine, thank you!",
    ]);

    const containerRef = useRef();
    useEffect(() => {
        const container = containerRef.current;
        // This will scroll to the bottom of the container when the messages change
        container.scrollTop = container.scrollHeight;
    }, [message]);


    const [updated, setUpdated] = useState('');
    //image upload

    const [imageUrl, setImageUrl] = useState(null);

    //custom code
    const [ticketStatus, setTicketStatus] = useState("open");
    const [ticketId, setTicketId] = useState(null);
    const [allChats, setAllChats] = useState([]);
    const [load, setLoad] = useState(false);
    const [userId, setUserId] = useState("");
    const { userData } = useSelector((state) => state.auth);
    const [selectedTicket, setSelectedTicket] = useState({});
    const [chatLoading, setChatLoading] = useState(false)


    const location = useLocation();

    useEffect(() => {
        // getAllTickets();
        const value = location?.state?.item;
        if (value != undefined) {
            setTicketId(value?.ticketId);
            getVoiceChats(value?.ticketId);
            setTicketStatus(value?.status);
            setSelectedTicket(value);
        }
    }, []);

    useEffect(() => {

        socket.emit("register", { ui: btoa(userData?.userId), role: "user" });

        socket.emit("subscribe", "marketPrice");

        socket.on("receive_message", (data) => {
            if (
                data.senderId == selectedTicket?.userId &&
                data.ticketId == ticketId
            ) {
                setAllChats((prevChats) => [...prevChats, data]);
                scrollToBottom();
            }
        });

        socket.on("close_userticket", (data) => {
            if (ticketId === data.ticketId) {

                setTicketStatus(data?.status);

                scrollToBottom();
            }
        });

        return () => {
            socket.off("register");
            socket.off("receive_message");
            socket.off("close_userticket");
            socket.emit("unSubscribe", "marketPrice");
        };
    }, [userData, ticketId]);

    const getVoiceChats = async (ticketId) => {
        setChatLoading(true)
        const response = await getChats(ticketId);
        if (response?.data?.success === true) {
            setAllChats(response.data.result);
            setChatLoading(false)

        } else {
            setChatLoading(false)

        }
    };


    const scrollToBottom = () => {
        if (containerRef.current) {
            containerRef.current.scrollTo({
                top: containerRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        scrollToBottom();
    }, [allChats]);

    const handleChangeSend = (event) => {
        setUpdated(event.target.value);
    };

    const handleEnterKeyPress = (e) => {
        if (e.key === "Enter") {
            handleClickSend();
        }
    };

    const handleClickSend = async () => {
        if (!updated && !imageUrl) return;

        const formData = new FormData();
        formData.append("ticketId", ticketId);
        if (userId) {
            formData.append("userId", userId);
        }

        formData.append("speaker", "user");
        // formData.append("to", fetchRole);
        formData.append("message", updated);

        if (imageUrl) {
            formData.append("chatImage", imageUrl);
        }
        const chatImage = imageUrl ? URL.createObjectURL(imageUrl) : null;

        try {
            const response = await createChat(formData);
            if (response?.data?.success === true) {
                setUpdated("");
                setLoad(false);
            } else {
                ToastError({ message: response?.data?.message, icon: false });

                setLoad(false);
            }

            const messagesocket = {
                message: updated.trim(),
                ticketId: ticketId,
                // receiverId: userId, // This should be the receiver's ID
                speaker: "user",
                chatImage: imageUrl || null,
                senderId: userData?.userId,
                // to: "admin",
            };
            socket.emit("send_message", { ...messagesocket });

            const messageset = {
                speaker: "user",
                message: updated.trim(),
                chatImage: chatImage || null,
                ticketId: ticketId,
                status: "progress",
            };

            setAllChats((prevChats) => [...prevChats, messageset]);

            scrollToBottom();

            setUpdated("");
            setImageUrl(null);

            containerRef.current.scroll({
                top: containerRef.current.scrollHeight,
                behavior: "smooth",
            });
        } catch (error) {
            console.error("Error creating chat message:", error);
        }
    };

    const formatTimestamp = (timestamp) => {
        return dayjs(timestamp).format("h:mm A"); // Format as "HH:mm A"
    };


    const pvtChat1 = (
        <div className="card-box chat-bx">
            <div className="colab-avatar-cont vr">
                <Stack direction="row" spacing={-0.5}>
                    {<div div className="cursor display-1">
                        <h3>{ticketId}</h3>
                    </div>}
                </Stack>
            </div>

            <div className="msglist-content" ref={containerRef}>
                <div className="colab-chat-area msg"  >
                    {
                        chatLoading === true ?
                            <ChatSkeletonLoader /> :

                            (allChats?.length > 0 ? (
                                allChats?.map((msg, ind) => {
                                    return (
                                        <div
                                            className="chat-area-inner-text user vr"
                                            style={{
                                                justifyContent: msg.speaker === "user" ? "right" : "left",
                                            }}
                                            key={ind}
                                        >
                                            <div className="collab-send-text-main">
                                                <div
                                                    className="username"
                                                    style={{
                                                        textAlign: msg.speaker === "user" ? "right" : "left",
                                                    }}
                                                >

                                                    {(msg?.chatImage || msg?.image) && (
                                                        <ImageChecker
                                                            src={
                                                                msg?.chatImage ||
                                                                process.env.REACT_APP_BACKEND_URL + msg?.image
                                                            } // Use the first available image
                                                            alt="chat attachment"
                                                            style={{
                                                                maxWidth: "200px",
                                                                maxHeight: "200px",
                                                                borderRadius: "8px",
                                                                marginTop: "10px",
                                                            }}
                                                            fallback={noImage}
                                                        />
                                                    )}
                                                </div>

                                                <div className="txt1">{msg.message}</div>

                                                <div className="time"> {formatTimestamp(msg.time)}</div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div
                                    style={{
                                        color: "white",
                                        display: 'flex', alignItems: "center", justifyContent: "center", height: "350px",
                                    }}
                                >
                                    <p>No Chat found!</p>
                                </div>
                            ))
                    }
                </div>

                <div className="" style={{ placeItems: "center" }}>
                    <div class="messageBox" >
                        {ticketStatus != "close" ? (
                            <>
                                <div class="fileUploadWrapper">
                                    <label for="file">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 337 337">
                                            <circle
                                                stroke-width="20"
                                                stroke="#F8BC36"
                                                fill="none"
                                                r="158.5"
                                                cy="168.5"
                                                cx="168.5"
                                            ></circle>
                                            <path
                                                stroke-linecap="round"
                                                stroke-width="25"
                                                stroke="#F8BC36"
                                                d="M167.759 79V259"
                                            ></path>
                                            <path
                                                stroke-linecap="round"
                                                stroke-width="25"
                                                stroke="#F8BC36"
                                                d="M79 167.138H259"
                                            ></path>
                                        </svg>
                                        <span class="tooltip">Add an image</span>
                                    </label>
                                    <input type="file" id="file" name="file" accept="image/jpeg,image/png" onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file && !['image/jpeg', 'image/png'].includes(file.type)) {
                                            ToastError({ message: "Only JPG, PNG, and JPEG files are allowed.", icon: false });
                                            return;
                                        }
                                        setImageUrl(file);
                                    }} />
                                </div>
                                {imageUrl && (
                                    <div style={{ position: "relative" }}>
                                        <div
                                            style={{
                                                marginTop: "10px",
                                                position: "absolute",
                                                top: "-150px",
                                                left: "-20px",
                                                backgroundColor: "rgb(65 65 65)",
                                                padding: "10px",
                                                width: "120px",
                                                height: "80px",
                                                textAlign: "center",
                                                borderRadius: '15px'
                                            }}
                                        >
                                            <img
                                                src={URL.createObjectURL(imageUrl)}
                                                alt="Preview"
                                                style={{
                                                    maxWidth: "100px",
                                                    maxHeight: "80px",
                                                    borderRadius: "8px",
                                                }}
                                            />
                                            <button
                                                onClick={() => setImageUrl(null)}
                                                style={{
                                                    position: "absolute",
                                                    top: "0px",
                                                    right: "0px",
                                                    // padding: "2px 3px",
                                                    background: "rgb(255, 65, 65)",
                                                    border: "none",
                                                    color: "#fff",
                                                    fontSize: "10px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                X
                                            </button>
                                        </div>
                                    </div>
                                )}
                                <input required="" placeholder="Message..." type="text" id="messageInput"
                                    value={updated}
                                    onChange={handleChangeSend}
                                    onKeyDown={handleEnterKeyPress}
                                />
                                <button id="sendButton" onClick={handleClickSend}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 664 663">
                                        <path
                                            fill="none"
                                            d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
                                        ></path>
                                        <path
                                            stroke-linejoin="round"
                                            stroke-linecap="round"
                                            stroke-width="33.67"
                                            stroke="#d2ac47"
                                            d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
                                        ></path>
                                    </svg>
                                </button>
                            </>
                        )
                            :
                            (
                                <Typography color="#fff">Ticket Closed</Typography>
                            )
                        }
                    </div>

                </div>



            </div>
        </div>
    )

    return (
        <div className="support-full">
            <Container className="xl-box" maxWidth="xl">
                <Grid container spacing={2} sx={{ justifyContent: "center", marginBottom: "60px", }}>
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        <div className="back" onClick={() => navigate(-1)}>
                            <div className="text-left"><a ><img src={backarr} /></a></div>
                        </div>
                    </Grid>
                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                        {pvtChat1}
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default Support2;
